<div class="banner-area-one shape-move">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 order-xl-1 order-lg-1 order-sm-2 order-2">
        <div class="banner-content-one">
          <div class="inner">
            <div class="pre-title-banner">
              <img src="assets/images/banner/bulb.png" width="22" alt="icon" />
              <span>Construa seu futuro com a Facint</span>
            </div>
            <h1 class="title-banner">
              Facint: Excelência em <br />
              Ensino de Qualidade
              <img src="assets/images/banner/02.png" alt="banner" />
            </h1>
            <p class="disc">
              Na Faculdade Facint, você encontra cursos atualizados, professores
              experientes e uma estrutura pensada para o seu sucesso.
            </p>
            <div class="banner-btn-author-wrapper">
              <a
                href="https://matricula.virtualfacint.com.br"
                class="rts-btn btn-primary with-arrow"
                >Inscreva-se <i class="fa-solid fa-arrow-right"></i
              ></a>
              <div class="sm-image-wrapper">
                <div class="images-wrap">
                  <img
                    src="assets/images/banner/girl.png"
                    width="48"
                    height="48"
                    alt="banner"
                  />
                  <img
                    class="two"
                    width="48"
                    height="48"
                    src="assets/images/banner/boy.png"
                    alt="banner"
                  />
                </div>
                <div class="info">
                  <h6 class="title">10.000+ alunos</h6>
                  <span>Torne-se aluno agora</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 order--xl-2 order-lg-2 order-sm-1 order-1">
        <div class="banner-right-img">
          <img src="assets/images/banner/01.png" alt="banner" />
        </div>
      </div>
    </div>
  </div>
  <div class="shape-image">
    <div class="shape one" data-speed="0.04" data-revert="true">
      <img src="assets/images/banner/shape/lapis.svg" alt="shape_image" />
    </div>
    <div class="shape two" data-speed="0.04">
      <img src="assets/images/banner/shape/trofeu.svg" alt="shape_image" />
    </div>
  </div>
</div>
